import React from 'react'
import Select from 'react-select'
import { CategorySkillOption } from '../WorkPreference/Registration/ThirdForm/types'
import styles from './TextAutoComplete.module.scss'

export type StyledTextAutoCompleteProps = {
  categoryId: number
  onChange: (option: { value: number, label: string }) => void
  skillOption: CategorySkillOption[]
  inputSize?: 'default' | 'small'
  dataCy?: string
} & React.SelectHTMLAttributes<HTMLSelectElement>


export const StyledTextAutoComplete: React.FC<StyledTextAutoCompleteProps> = (props: StyledTextAutoCompleteProps) => {
  const sizeClass = props.inputSize === 'small' ? 'text-S px-S py-XS' : 'text-M p-S'
  const controlClass = (state: { isFocused: boolean }) => `
    border-1 rounded ${sizeClass} w-full text-member-gray-100
    disabled:bg-member-gray-30 ${state.isFocused ? 'shadow-none' : ''}
  `

  const menuClass = props.inputSize === 'small' ? 'text-S text-member-gray-100' : 'text-M text-member-gray-100'

  return (
    <Select
      {...props}
      classNamePrefix="select"
      className={styles.select}
      options={props.skillOption}
      onChange={(selectedOption) => {
        if (selectedOption) {
          props.onChange({
            value: selectedOption.value,
            label: selectedOption.label
          });
        }
      }}
      components={{
        IndicatorSeparator: () => null,
        DropdownIndicator: () => null,
      }}
      styles={
        {
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: state.isFocused ? 'var(--color-member-green-100) !important' : baseStyles.borderColor,
          }),
        }
      }
      classNames={{
        control: (state) => controlClass(state),
        input: () => 'p-0 m-0',
        singleValue: () => 'm-0',
        valueContainer: () => 'p-0',
        placeholder: () => 'm-0 text-member-gray-40',
        menu: () => menuClass,
      }}
      isDisabled={props.disabled}
    />
  )
}
